export class RepositoryFilter {
  pageIndex: number = 1;
  pageSize: number = 0;
  filters: RepositoryFilterItem[] = [];

  static getFilterTypes() {
    return Object.values(RepositoryFilterType);
  }
}

export class RepositoryFilterItem {
  propertyName: string = "";
  propertyValue: string = "";
  filterType = RepositoryFilterType.undefined;
}


export enum RepositoryFilterType {
  undefined = 'Undefined',
  equal = 'Equal',
  greaterThan = 'GreaterThan',
  greaterThanOrEqual = 'GreaterThanOrEqual',
  lessThan = 'LessThan',
  lessThanOrEqual = 'LessThanOrEqual',
  notEqual = 'NotEqual',
  startsWith = 'StartsWith',
  contains = 'Contains'
}

export class queryResult {
  count: number;
  data: any[] = [];
}

export class keyValuePair {
  key: string;
  value: string;

  constructor(k: string, v: string) {
    this.key = k;
    this.value = v;
  }

  
}
